import React, { useState } from "react";
import "../css/CuadroDeHonor.css";

// ==============================
// Imágenes
// ==============================

import Cuadro01 from "../img/cuadrohonor/cuadro01.jpg";
import Cuadro02 from "../img/cuadrohonor/cuadro02.png";
import Cuadro03 from "../img/cuadrohonor/cuadro03.png";
import Cuadro04 from "../img/cuadrohonor/cuadro04.jpg";
//import Cuadro05 from "../img/cuadrohonor/cuadro05.jpeg";

// ==============================
// Información
// ==============================

const cuadroHonorData = [

   {
        id: 1,
        title: "Mejor Asistencia",
        subtitle: "Mes de Agosto 2026",
        description:
            "3° básico Curso destacado por mantener una excelente asistencia durante el Mes.",
        imageUrl: Cuadro01,
    }, 

    {
        id: 2,
        title: "Mejor Asistencia",
        subtitle: " Mes de Agosto 2026",
        description:

        "5° básico Curso destacado por mantener una excelente asistencia durante el Mes.",
           /* ' "Participación destacada en competencias de ajedrez representando a nuestra escuela.", */
        imageUrl: Cuadro02,
    },

    {
        id: 3,
         title: "Mejor Asistencia",
        subtitle: " Mes de Agosto 2026",
        description:
           
           "7° básico Curso destacado por mantener una excelente asistencia durante el Mes.",
        imageUrl: Cuadro03,
    },

    {
        id: 4,
         title: "Mejor Asistencia",
        subtitle: " Mes de Agosto 2026",
        description:
           "8° básico Curso destacado por mantener una excelente asistencia durante el Mes.",
        imageUrl: Cuadro04,
    },

    /*{
        id: 5,
        title: "Campeonato de Cueca",
        subtitle: "",
        description:
            "Kinder: Perla Escolástico y Erick Ellie",
        imageUrl: Cuadro05,
    }*/

];

// ==============================

const CuadroDeHonor = () => {

    const [imagenSeleccionada, setImagenSeleccionada] = useState(null);

    const abrirImagen = (imagen) => {
        setImagenSeleccionada(imagen);
    };

    const cerrarImagen = () => {
        setImagenSeleccionada(null);
    };

    return (

        <section
            id="cuadrohonor-component"
            className="esc-cuadrohonor-section"
        >

            <div className="esc-cuadrohonor-container">

                <h2 className="esc-cuadrohonor-title">

                    Cuadro de Honor

                </h2>

                <p className="esc-cuadrohonor-subtitle">

                    En este espacio destacamos el esfuerzo, la dedicación y los logros
                    de nuestros estudiantes en las distintas actividades desarrolladas
                    durante el año escolar.

                </p>

                <div className="esc-cuadrohonor-grid">

                    {cuadroHonorData.map((item) => (

                        <article
                            key={item.id}
                            className="esc-cuadrohonor-card"
                        >

                            <div className="esc-cuadrohonor-header">

                                {item.title}

                            </div>

                            <div className="esc-cuadrohonor-subheader">

                                {item.subtitle}

                            </div>

                            <div
                                className="esc-cuadrohonor-image-wrapper"
                                onClick={() => abrirImagen(item.imageUrl)}
                            >

                                <img
                                    src={item.imageUrl}
                                    alt={item.title}
                                    className="esc-cuadrohonor-image"
                                />

                                <div className="esc-cuadrohonor-overlay">

                                    <div className="esc-cuadrohonor-zoom">

                                         🔍

                                    </div>

                                </div>

                            </div>

                            <div className="esc-cuadrohonor-description">

                                {item.description}

                            </div>

                        </article>

                    ))}

                </div>

            </div>

            {imagenSeleccionada && (

                <div
                    className="esc-cuadrohonor-modal"
                    onClick={cerrarImagen}
                >

                    <img
                        src={imagenSeleccionada}
                        alt="Imagen ampliada"
                        className="esc-cuadrohonor-modal-image"
                        onClick={(e) => e.stopPropagation()}
                    />

                    <button
                        className="esc-cuadrohonor-close"
                        onClick={cerrarImagen}
                    >
                        ✕
                    </button>

                </div>

            )}

        </section>

    );

};

export default CuadroDeHonor;